import { ProtocolAddress } from '../../../types/protocol'
import {
  genrateLevelAddress,
  genrateWindowsBaseLayerAddress,
  genrateStaticLightEffectPresetAddressName,
  genrateDynamicLightEffectAddressLevel,
  genrateStaticLightEffectAddressLevel,
  genrateStaticLightEffectPresetAddressLevel,
  genrateMacroAddressLevel,
  genrateMacroNameAddressLevel,
  genrateStaticLightRGBAddressLevel,
  genrateKeyTravelAndDeadZoneAddress,
  genrateCalibrationAddress,
  genrateSideLightEffectAddressLevel,
} from './addressGenerators'

export const ADDRESS_CH585M = {
  CURRENT_CONNECT_PROTOCOL: [0x2c, 0x00], //TODO 不确定, 似乎没用

  CONFIG_CURRENT: [0x2d, 0x00], //0~3 表示配置 1/2/3/4, 其它： 默认为配置 1

  FW_VERSION_0: [0x08, 0x00], //固件版本字节 1（ 最低字节）
  FW_VERSION_1: [0x09, 0x00], //固件版本字节 2
  FW_VERSION_2: [0x0a, 0x00], //固件版本字节 3
  FW_VERSION_3: [0x0b, 0x00], //固件版本字节 4（ 最高字节）

  ADATIVE_CALIBRATION_ENABLE: genrateCalibrationAddress(0x03cc), // 自适应校准位

  STATIC_LIGHTING_EFFECT_COUNT: [0x2f, 0x00], //出厂自带静态灯效数量

  CONFIG_ADDRESS: genrateLevelAddress(0x0000), //配置初始地址
  CONFIG_NAME: genrateLevelAddress(0x00f0), //配置名称
  FN_LOCK: genrateLevelAddress(0x0004), //FnLock: 0: 没锁; 1: 锁定
  WIN_LOCK: genrateLevelAddress(0x0005), //WinLock: 0: 没锁; 1: 锁定
  FULL_KEY_LOCK: genrateLevelAddress(0x0006), //FullKeyLock: 0: 没锁； 1： 锁定, 全键无冲锁标志
  BACKLIGHT_SWITCH: genrateLevelAddress(0x0007), //背光开关: 0: OFF; 1: ON; 0xff: 不支持背光

  BACKLIGHT_EFFECT: genrateLevelAddress(0x0008), //当前背光灯效模式 TODO 轴下灯
  // TODO 全局亮度和速度不知道有什么用
  GLOBAL_BRIGHTNESS: genrateLevelAddress(0x0009), //全局亮度档位(0~100%)， 60%（ 默认） TODO 装饰灯
  GLOBAL_SPEED: genrateLevelAddress(0x000a), //全局速度档位（ 0~100%） ,60%速度（ 默认）

  // DynamicLightEffect 跟随配置变动 动态模式参数, 参数长度为8
  DYNAMIC_LIGHT_EFFECT_ADDRESS_1: genrateLevelAddress(0x0034),
  DYNAMIC_LIGHT_EFFECT_ADDRESS_2: genrateLevelAddress(0x003c),
  DYNAMIC_LIGHT_EFFECT_ADDRESS_3: genrateLevelAddress(0x0044),
  DYNAMIC_LIGHT_EFFECT_ADDRESS_4: genrateLevelAddress(0x004c),
  DYNAMIC_LIGHT_EFFECT_ADDRESS_5: genrateLevelAddress(0x0054),
  DYNAMIC_LIGHT_EFFECT_ADDRESS_6: genrateLevelAddress(0x005c),
  DYNAMIC_LIGHT_EFFECT_ADDRESS_7: genrateLevelAddress(0x0064),
  DYNAMIC_LIGHT_EFFECT_ADDRESS_8: genrateLevelAddress(0x006c),

  // 全局 RT 参数
  GLOBAL_RT_ID: genrateLevelAddress(0x008c), // 全局 RT 配置 ID（0~3）4 档配置选择
  GLOBAL_RT_SWITCH: genrateLevelAddress(0x008d), // 全局 RT 选择；（打开后单独设置 RT 功能失效）
  GLOBAL_RT_ENABLE: genrateLevelAddress(0x008e), // 全局 RT 使能
  GLOBAL_RT_0_TRAVEL: genrateLevelAddress(0x0090), // 全局 RT ID 0 处键行程及死区定义
  GLOBAL_RT_1_TRAVEL: genrateLevelAddress(0x0098), // 全局 RT ID 1 处键行程及死区定义
  GLOBAL_RT_2_TRAVEL: genrateLevelAddress(0x00a0), // 全局 RT ID 2 处键行程及死区定义
  GLOBAL_RT_3_TRAVEL: genrateLevelAddress(0x00a8), // 全局 RT ID 3 功能关闭，使用单独 RT 设置挡位
  // RT ID 3 键程及死区定义(6x22 列,单键占用 8 字节)
  RT_3_TRAVEL_LIST: genrateKeyTravelAndDeadZoneAddress(0x0100),

  // 动态模式的参数 地址偏移，需要配合DYNAMIC_LIGHT_EFFECT_ADDRESS_x 使用
  DYNAMIC_BRIGHTNESS_OFFSET: 0,
  DYNAMIC_SPEED_OFFSET: 1,
  DYNAMIC_COLOR_TYPE_OFFSET: 2,
  DYNAMIC_COLOR_R_OFFSET: 4,
  DYNAMIC_COLOR_G_OFFSET: 5,
  DYNAMIC_COLOR_B_OFFSET: 6,

  // 按键定义(最大定义矩阵 6 行 x22 列键)
  // windows 基础层
  WIN_KEY_MATRIX: genrateWindowsBaseLayerAddress(0x0000, 'WINDOWS_BASE_LAYER_ADDRESS'),
  // windows Fn 层
  WIN_FN_KEY_MATRIX: genrateWindowsBaseLayerAddress(0x0000, 'WINDOWS_FN_LAYER_ADDRESS'),
  // MAC 基础层
  MAC_KEY_MATRIX: genrateWindowsBaseLayerAddress(0x0000, 'MAC_BASE_LAYER_ADDRESS'),
  // MAC Fn 层
  MAC_FN_KEY_MATRIX: genrateWindowsBaseLayerAddress(0x0000, 'MAC_FN_LAYER_ADDRESS'),

  // StaticLightEffect中的配置
  STATIC_LIGHT_R0C0: genrateStaticLightEffectAddressLevel(0x0000), // Row 0 Column 0
  STATIC_LIGHT_NAME: genrateStaticLightEffectAddressLevel(0x0210),
  // 自定义静态灯效RGB地址
  STATIC_CUSTOM_LIGHT_RGB: genrateStaticLightRGBAddressLevel(0x00),

  STATIC_LIGHT_EFFECT_ADDRESS_NAME_LEVEL: genrateStaticLightEffectPresetAddressName(0x00), // 静态灯效名称
  // 背光灯效静态模式参数表
  STATIC_LIGHT_TYPE: genrateStaticLightEffectPresetAddressLevel(0x00), // 背光灯效静态模式类型 1 无渐变 2 上下渐变 3左右渐变
  STATIC_LIGHT_BRIGHTNESS: genrateStaticLightEffectPresetAddressLevel(0x01),
  // 固定无渐变类型
  STATIC_LIGHT_EFFECT_MODE: genrateStaticLightEffectPresetAddressLevel(0x02), // 静态灯效 0~4：默认显示 0xff: 显示为对应的 RGB 存储区
  // 渐变类型起始-结束颜色
  STATIC_GRADIENT_COLOR_START_R: genrateStaticLightEffectPresetAddressLevel(0x02),
  STATIC_GRADIENT_COLOR_START_G: genrateStaticLightEffectPresetAddressLevel(0x03),
  STATIC_GRADIENT_COLOR_START_B: genrateStaticLightEffectPresetAddressLevel(0x04),
  STATIC_GRADIENT_COLOR_END_R: genrateStaticLightEffectPresetAddressLevel(0x05),
  STATIC_GRADIENT_COLOR_END_G: genrateStaticLightEffectPresetAddressLevel(0x06),
  STATIC_GRADIENT_COLOR_END_B: genrateStaticLightEffectPresetAddressLevel(0x07),

  // 背光灯效动态模式参数表
  DYNAMIC_LIGHT_BRIGHTNESS: genrateDynamicLightEffectAddressLevel(0x00),
  DYNAMIC_LIGHT_SPEED: genrateDynamicLightEffectAddressLevel(0x01),
  DYNAMIC_LIGHT_COLOR_TYPE: genrateDynamicLightEffectAddressLevel(0x02), // 颜色类型 0 随机，也就是ui中的炫彩色 1 固定颜色
  DYNAMIC_LIGHT_COLOR_R: genrateDynamicLightEffectAddressLevel(0x04),
  DYNAMIC_LIGHT_COLOR_G: genrateDynamicLightEffectAddressLevel(0x05),
  DYNAMIC_LIGHT_COLOR_B: genrateDynamicLightEffectAddressLevel(0x06),

  // 侧灯动态模式参数表
  /** 侧灯/充电灯/氛围灯 4 字节使能寄存器基址（+0x00B0~0x00B3） */
  SIDE_LIGHT_ENABLE: genrateLevelAddress(0x00b0),
  SIDE_DYNAMIC_LIGHT_MODE: genrateLevelAddress(0xb2), // 侧灯模式（单一字节）
  SIDE_DYNAMIC_LIGHT_OPEN: genrateLevelAddress(0xb3), // 侧灯开关（单一字节）
  SIDE_DYNAMIC_LIGHT_BRIGHTNESS: genrateSideLightEffectAddressLevel(0x00),
  SIDE_DYNAMIC_LIGHT_SPEED: genrateSideLightEffectAddressLevel(0x01),
  SIDE_DYNAMIC_LIGHT_COLOR_TYPE: genrateSideLightEffectAddressLevel(0x02), // 颜色类型 0 随机，也就是ui中的炫彩色 1 固定颜色
  SIDE_DYNAMIC_LIGHT_COLOR_R: genrateSideLightEffectAddressLevel(0x04),
  SIDE_DYNAMIC_LIGHT_COLOR_G: genrateSideLightEffectAddressLevel(0x05),
  SIDE_DYNAMIC_LIGHT_COLOR_B: genrateSideLightEffectAddressLevel(0x06),

  // LOGO_LED: genrateLevelAddress(0x0010), //LOGO LED 模式,0: 灭； 1: 常亮; 2: 呼吸; 0xff: 无此功能
  // GLOBAL_ABSOLUTE_TRIGGER_LOW: genrateLevelAddress(0x0014), //全局绝对触发位置低字节, 可设范围 1~400 表示 0.01~4.00mm, 默认:1.0mm(100)
  // GLOBAL_ABSOLUTE_TRIGGER_HIGH: genrateLevelAddress(0x0015), //全局绝对触发位置高字节
  // GLOBAL_DEAD_ZONE: genrateLevelAddress(0x0016), //全局按键死区设置,可设范围 1~80 表示 0.01 ~ 0.80mm, 默认:0.2mm(20)
  // GLOBAL_FAST_TRIIGGER_SWITCH: genrateLevelAddress(0x0017), //全局连续快速触发开关,0:关闭； 1： 打开, 默认: 0
  // GLOBAL_FAST_TRIIGGER_SENSITIVITY_LOW: genrateLevelAddress(0x0018), //全局快速触发灵敏度设置低字节,可设范围 1~400 表示 0.01~4.00mm,默认: 1.00mm(100)
  // GLOBAL_FAST_TRIIGGER_SENSITIVITY_HIGH: genrateLevelAddress(0x0019), //全局快速触发灵敏度设置高字节
  // SWAP_WASD: genrateLevelAddress(0x001c), //WASD 与上下左右键位置交换

  // SLEEP_TIME: genrateLevelAddress(0x0030), //休眠时间， 单位分钟， 可设范围 3~120， 默认: 30
  // REPORT_RATE_WIRELESSRECEIVER: genrateLevelAddress(0x002c), //2.4G 配 4K 接收器的回报率定义 0x08=125Hz 0x04=250Hz 0x02=500Hz 0x01=1000Hz,0x84:2K; 0x82: 4K; 0x81: 8K, 默认=0x82
  // REPORT_RATE_USB: genrateLevelAddress(0x002e), //USB 高速连接时的的回报率定义 0x08=125Hz 0x04=250Hz 0x02=500Hz 0x01=1000Hz, 0x84:2K; 0x82: 4K; 0x81: 8K, 默认=0x82

  MACRO_PACKAGE_ADDRESS: genrateMacroAddressLevel(0x00),
  MACRO_NAME_ADDRESS: genrateMacroNameAddressLevel(0x00),

  // IAP升级程序区
  IAP_UPDATE_ADDRESS: 0x00003000,
} as const satisfies ProtocolAddress
